import io from 'socket.io-client';

//let socket = io("//localhost:8000");
//let socket = io("https://www.socket.institutobilinguelasnaciones.com");
let socket = io("https://correo.institutobilinguelasnaciones.com");
//socket.institutobilinguelasnaciones.com

export default socket;
